module.exports = __webpack_public_path__ + "img/rectangle_female_disable.908b2205.svg";